export default __webpack_public_path__ + "static/media/servifacil_payment.8129fd38.png";